module.exports = __webpack_public_path__ + "img/成立海报-封面.4cfca1e9.png";